import { render, staticRenderFns } from "./WideCardInner.vue?vue&type=template&id=41c25caa&"
import script from "./WideCardInner.vue?vue&type=script&lang=js&"
export * from "./WideCardInner.vue?vue&type=script&lang=js&"
import style0 from "./WideCardInner.vue?vue&type=style&index=0&id=41c25caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports